import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { addAlert, removeAlert, clearAlerts, showAlert } from './actions';

const alertsSelector = (state) => state.alerts.list;

export const useAlerts = {
  state: () => {
    const alerts = useSelect(alertsSelector);
    return { alerts };
  },
  actions: () => {
    return {
      addAlert: useAction(addAlert),
      removeAlert: useAction(removeAlert),
      clearAlerts: useAction(clearAlerts),
      showAlert: useAction(showAlert),
    };
  },
};
